import { Formik, FormikHelpers } from "formik";
import {
  ControlcenterMelcoControlCenterModelsUserSerialNumberResponse,
  useFormSubmit,
} from "melco-shared-logic";
import { useQueryClient } from "react-query";
import { DirtyFormPrompt } from "../../../form/DirtyFormPrompt";
import { DisplayChangeLevelLicenseForm } from "./DisplayChangeLevelLicenseForm";
import { useLicenseManagerChangeLevel } from "../../../../hooks/licensemanager/useLicenseManagerChangeLevel";

export type ChangeLevelLicenseFormValueType = {
  serial_number: string;
  melco_customer_id?: string | null;
  language?: string | null;
};

type ChangeLevelLicenseFormProps = {
  onChangeLevelLicenseCallBackFn: (
    obj: ChangeLevelLicenseFormValueType,
    license:
      | ControlcenterMelcoControlCenterModelsUserSerialNumberResponse
      | undefined,

  ) => void;
  licenseFormValues?: ChangeLevelLicenseFormValueType
};

export const ChangeLevelLicenseForm: React.FC<ChangeLevelLicenseFormProps> = ({
  onChangeLevelLicenseCallBackFn,
  licenseFormValues }) => {
  const queryClient = useQueryClient();
  const queryKey = "changelevellicensemanage";
  const licenseManager = useLicenseManagerChangeLevel();
  const onSubmit = async (
    values: ChangeLevelLicenseFormValueType,
    formikHelpers: FormikHelpers<ChangeLevelLicenseFormValueType>
  ) => {
    await onChangeLevelSerialNumber(values, formikHelpers, {
      isManuallyResettingForm: true,
    });
  };

  const createLicenseFormToInitialValues = (
    formvalues: ChangeLevelLicenseFormValueType
  ) => {
    const { serial_number, melco_customer_id, language } = formvalues;

    const initialValues: ChangeLevelLicenseFormValueType = {
      serial_number: serial_number ?? "",
      melco_customer_id: melco_customer_id ?? "",
      language: language ?? "",
    };

    return initialValues;
  };

  const initialValues: ChangeLevelLicenseFormValueType = {
    serial_number: licenseFormValues?.serial_number ?? "",
    melco_customer_id: licenseFormValues?.melco_customer_id ?? "",
    language: licenseFormValues?.language ?? "",
  };

  const handleChangeLevelLicense = async (
    values: ChangeLevelLicenseFormValueType,
    formikHelpers: FormikHelpers<ChangeLevelLicenseFormValueType>,
    options: {}
  ) => {
    //setOpenAskConfirmationBoxTrigger(!openAskConirmationBoxTrigger)
    let newEntity:
      | ControlcenterMelcoControlCenterModelsUserSerialNumberResponse
      | undefined = await licenseManager({
        serial_number: values.serial_number,
        step: 1,
        melco_customer_id: values.melco_customer_id,
        language: values.language,
      });
    console.log(newEntity);
    formikHelpers.resetForm({
      values: newEntity
        ? createLicenseFormToInitialValues({
          serial_number: newEntity?.serial_number ?? "",
          melco_customer_id: newEntity?.melco_customer_id ?? "",
          language: newEntity?.language ?? "",
        })
        : createLicenseFormToInitialValues({
          serial_number: "",
          melco_customer_id: "",
          language: "",
        }),
    });
    queryClient.setQueryData(queryKey, newEntity);
    onChangeLevelLicenseCallBackFn(values, newEntity);
  };

  const formSubmitToChangeLevelLicense = () => {
    return [
      async (
        values: ChangeLevelLicenseFormValueType,
        formikHelpers: FormikHelpers<ChangeLevelLicenseFormValueType>
      ) => {
        return handleChangeLevelLicense(values, formikHelpers, {});
      },
      {
        translationPrefix: ["licensemanager", "changelevel"].join("."),
        onError: () => {
          // refetch entity from server
          queryClient.invalidateQueries(queryKey);
        },
      },
    ] as const;
  };

  const onChangeLevelSerialNumber = useFormSubmit(
    ...formSubmitToChangeLevelLicense()
  );

  return (
    <>
      <Formik
        initialValues={initialValues}
        onSubmit={onSubmit}
        enableReinitialize
      >
        <DirtyFormPrompt>
          <DisplayChangeLevelLicenseForm />
        </DirtyFormPrompt>
      </Formik>
    </>
  );
};
